export class BookmarkConstant {
  static readonly MAX_PER_USER = 20;
}
